import { useState, useCallback } from 'react';
import { Question, STANDARD_QUESTION_COUNT } from '../types/game';

const STORAGE_KEY = 'histocracy_seen_questions';

function loadSeen(): number[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function saveSeen(ids: number[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
}

export function useSeenQuestions() {
  const [seenIds, setSeenIds] = useState<Set<number>>(() => new Set(loadSeen()));

  const markSeen = useCallback((ids: number[]) => {
    setSeenIds((prev) => {
      const next = new Set(prev);
      ids.forEach((id) => next.add(id));
      saveSeen(Array.from(next));
      return next;
    });
  }, []);

  const getUnseen = useCallback(
    (pool: Question[], minRequired: number = STANDARD_QUESTION_COUNT): Question[] => {
      const unseen = pool.filter((q) => !seenIds.has(q.id));
      // Auto-reset: if not enough unseen questions, return full pool
      if (unseen.length < minRequired) {
        setSeenIds(new Set());
        saveSeen([]);
        return pool;
      }
      return unseen;
    },
    [seenIds],
  );

  return { seenIds, markSeen, getUnseen };
}
